module.exports = __webpack_public_path__ + "img/1.92d7aef0.jpg";